module.exports = __webpack_public_path__ + "1575c05cdbe87c6555578fbc1ece274a.png";


//////////////////
// WEBPACK FOOTER
// ./Res/img/top_logo.png
// module id = 340
// module chunks = 1